import { GKButton, GKClientDataGrid } from "components";
import { useFetchQuery } from "hooks/useQueries";
import { useState } from "react";
import { updatePortfolio } from "store/slices/portfolioSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { CLIENT_DEMAT_BY_ID } from "utils/apiRoutes";
import { extraColumnsField } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import DematModal from "./DematModal";

const DematInfoTab = ({ portfolioData }: any) => {
  const [openModal, setOpenModal] = useState(false);
  const [updateData, setUpdateData] = useState(null);

  const dispatch = useAppDispatch();

  const updatePortfolioLoading = useAppSelector(
    (state) => state?.portfolio?.loading,
  );

  const { data, isFetching, refetch } = useFetchQuery({
    key: [QueryKeys.PORTFOLIO_DEMAT_ACCOUNT],
    route: CLIENT_DEMAT_BY_ID(portfolioData?.client),
  });

  return (
    <>
      <GKClientDataGrid
        name="demateInfo"
        density="compact"
        headerComponent={
          <GKButton
            variant="outlined"
            size="small"
            color="dark"
            onClick={() => {
              setOpenModal(true);
              setUpdateData(null);
            }}
          >
            Add Demat Account
          </GKButton>
        }
        loading={updatePortfolioLoading || isFetching}
        rows={data?.data?.dematAccounts || []}
        onRowClick={(params) => {
          setOpenModal(true);
          setUpdateData(params.row);
        }}
        columns={[
          {
            ...extraColumnsField("Broker Name", "brokerName", 150, 1),
          },
          {
            ...extraColumnsField("Demat ID", "dematId", 150, 1),
          },
          {
            ...extraColumnsField("Depository", "depositary", 150, 1),
          },
          {
            ...extraColumnsField(
              "Unique Client Code",
              "uniqClientCode",
              100,
              1,
            ),
          },
          {
            ...extraColumnsField("Assign", "assign", 100, 1),
            align: "right",
            headerAlign: "right",
            renderCell: (params) => {
              return (
                params?.row?.id !== portfolioData?.dematAccount && (
                  <GKButton
                    variant="link"
                    color="dark"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(
                        updatePortfolio({
                          id: portfolioData?.id,
                          portfolioUpdateData: {
                            ...portfolioData,
                            dematAccount: params?.row?.id,
                          },
                        }),
                      );
                    }}
                  >
                    Assign
                  </GKButton>
                )
              );
            },
          },
        ]}
      />
      {openModal && (
        <DematModal
          open={openModal}
          setOpen={setOpenModal}
          allAccounts={data?.data}
          updateData={updateData}
          clientId={portfolioData?.client}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default DematInfoTab;
